export const formatDate = (value?: string | null) => {
  if (!value) return '—'
  return new Intl.DateTimeFormat('fr-FR').format(new Date(value.length === 10 ? `${value}T12:00:00` : value))
}

export const formatDateTime = (value?: string | null) => {
  if (!value) return '—'
  return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
}

export const formatNumber = (value?: number | null) => value == null ? '—' : new Intl.NumberFormat('fr-FR').format(value)

export const isTrue = (value?: number | boolean | null) => value === true || value === 1

export const normalizeSearch = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr')
